import BaseService from './BaseService';
import entities from 'src/config/entities'

class SegmentGroupService extends BaseService {

  constructor () {
    super({entity: entities.SEGMENT_GROUP})
  }

  async createSegmentForJobBoard(data) {
    try {
      let result = await this.instance.post(`${data.segment_group_id}/job-boards`, data);
      this._handleSuccess({ translationKey: 'generic.update.success', data});
      return result;
    } catch(e) {
      this._handleError({ translationKey: 'generic.update.error', error: e, id: data.segment_group_id})
    }
  }

  async deleteSegmentGroupForJobBoard(data) {
    try {
      let result = await this.instance.delete(`/${data.segment_group_id}/job-boards/${data.job_board_id}`);
      this._handleSuccess({ translationKey: 'generic.delete.success', data});
      return result;
    } catch(e) {
      this._handleError({ translationKey: 'generic.delete.error', error: e, id: data.segment_group_id})
    }
  }


}

export default new SegmentGroupService()
